import {
	type AgencyId,
	type BondRequestExtractionId,
	type SuretyAccountId,
	type SuretyQuoteId,
} from "@inrev/common";

export const bondFormTemplatesQueryKey = () => ["bondFormTemplates"] as const;

export const bondRequestAttachmentsQueryKey = (quoteId: SuretyQuoteId) =>
	["bondRequests", quoteId, "attachments"] as const;

export const bondRequestContractExtractionsQueryKey = (quoteId: SuretyQuoteId) =>
	["bondRequests", quoteId, "contractExtractions"] as const;

export const bondRequestExtractionQueryKey = (
	id: BondRequestExtractionId,
	quoteId: SuretyQuoteId,
) => ["bondRequests", quoteId, "bondRequestExtractions", id] as const;

export const bondRequestExtractionsQueryKey = (quoteId: SuretyQuoteId) =>
	["bondRequests", quoteId, "bondRequestExtractions"] as const;

export const bondRequestPreviewsQueryKey = (accountId?: SuretyAccountId) =>
	accountId
		? (["previews", "bond-requests", accountId] as const)
		: (["previews", "bond-requests"] as const);

export const bondRequestsQueryKey = (quoteId?: string) =>
	quoteId ? (["bondRequests", quoteId] as const) : (["bondRequests"] as const);

export const bondRequestRedirectQueryKey = (quoteId: SuretyQuoteId) =>
	["bondRequestRedirect", quoteId] as const;

export const bondRequestBondFormQueryKey = (quoteId: SuretyQuoteId) =>
	["bondRequests", quoteId, "bondForm"] as const;

export const bondRequestIssuanceQueryKey = (quoteId: SuretyQuoteId) =>
	["bondRequests", quoteId, "issuance"] as const;

export const bondRequestLatestUnderwritingQueryKey = (quoteId: SuretyQuoteId) =>
	["bondRequests", quoteId, "underwritings", "latest"] as const;

export const carrierAgencyRelationshipsQueryKey = (agencyId?: AgencyId) =>
	["carrierAgencyRelationships", agencyId] as const;
